import { FaCalendarDay, FaUserCheck, FaBus, FaHome, FaClock, FaWheelchair, FaHeartbeat, FaComments, FaFileMedical, FaCheck, FaPalette, FaRunning, FaMusic, FaUtensils, FaLeaf, FaPuzzlePiece, FaShoppingBasket, FaCoffee, FaQuestionCircle, FaPhone, FaEnvelope, FaHeart } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styles from './Services.module.css'

const Services = () => {
  const activities = [
    { icon: FaPalette, title: 'Creatieve workshops', description: 'Schilderen, knutselen, handwerken' },
    { icon: FaRunning, title: 'Sport & Beweging', description: 'Wandelen, fitness, dansen' },
    { icon: FaMusic, title: 'Muziek & Cultuur', description: 'Zingen, muziek maken, theater' },
    { icon: FaUtensils, title: 'Koken & Bakken', description: 'Samen koken en smullen' },
    { icon: FaLeaf, title: 'Tuinieren', description: 'Werken in de moestuin' },
    { icon: FaPuzzlePiece, title: 'Spellen & Puzzels', description: 'Gezelligheid en ontspanning' },
    { icon: FaShoppingBasket, title: 'Uitstapjes', description: 'Museum, dierentuin, markt' },
    { icon: FaCoffee, title: 'Ontspanning', description: 'Lezen, koffie drinken, kletsen' }
  ]

  return (
    <div className={styles.servicesPage}>
      {/* Page Header */}
      <section className={styles.pageHeader}>
        <div className="container">
          <h1 className="fade-in">Onze Diensten</h1>
          <p className="fade-in-delay">Professionele zorg op maat voor elk individu</p>
        </div>
      </section>

      {/* Dagbesteding Section */}
      <section id="dagbesteding" className={styles.serviceSection}>
        <div className="container">
          <div className={styles.serviceGrid}>
            <div className={`${styles.serviceImage} fade-in`}>
              <div style={{ 
                display: 'grid', 
                gap: '0.75rem', 
                gridTemplateColumns: window.innerWidth > 768 ? '1fr 1fr' : '1fr',
                height: '100%'
              }} className={styles.photoGrid}>
                <img 
                  src="/assets/img/dagbesteding-activiteit-1.jpg" 
                  alt="Deelnemers aan dagbesteding tijdens een gezellige activiteit"
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    objectPosition: 'center',
                    borderRadius: '8px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)' 
                  }}
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=600&fit=crop'
                  }}
                />
                <img 
                  src="/assets/img/dagbesteding-activiteit-2.jpg" 
                  alt="Begeleider met deelnemers tijdens uitstapje"
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover',
                    objectPosition: 'center',
                    borderRadius: '8px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)' 
                  }}
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=600&fit=crop'
                  }}
                />
              </div>
            </div>
            <div className={`${styles.serviceContent} fade-in-delay`}>
              <div className={styles.badge}>
                <FaCalendarDay aria-hidden="true" /> Dagbesteding
              </div>
              <h2>Zinvolle en gestructureerde dagbesteding</h2>
              <p>
                Onze dagbesteding biedt een veilige en stimulerende omgeving waar ouderen 
                kunnen deelnemen aan diverse activiteiten die aansluiten bij hun interesses 
                en mogelijkheden. Wij werken voornamelijk met <strong>multiculturele cliënten</strong> en 
                bieden activiteiten die respectvol zijn naar verschillende culturen en achtergronden.
              </p>
              <p>
                Van creatieve workshops tot sport en spel, van sociale activiteiten tot 
                ontspanning - wij zorgen voor een gevarieerd en zinvol dagprogramma waar 
                iedereen zich welkom voelt.
              </p>
              
              <div className={styles.featureList}>
                <div className={styles.featureItem}>
                  <FaCheck className={styles.checkIcon} aria-hidden="true" />
                  <div>
                    <h4>Gevarieerd activiteitenprogramma</h4>
                    <p>Dagelijks nieuwe activiteiten afgestemd op de groep</p>
                  </div>
                </div>
                <div className={styles.featureItem}>
                  <FaCheck className={styles.checkIcon} aria-hidden="true" />
                  <div>
                    <h4>Kleinschalige groepen</h4>
                    <p>Persoonlijke aandacht in een veilige omgeving</p>
                  </div>
                </div>
                <div className={styles.featureItem}>
                  <FaCheck className={styles.checkIcon} aria-hidden="true" />
                  <div>
                    <h4>Gekwalificeerde begeleiding</h4>
                    <p>Ervaren begeleiders die inspelen op individuele behoeften</p>
                  </div>
                </div>
                <div className={styles.featureItem}>
                  <FaCheck className={styles.checkIcon} aria-hidden="true" />
                  <div>
                    <h4>Inclusie en participatie</h4>
                    <p>Deelname aan activiteiten in de lokale gemeenschap</p>
                  </div>
                </div>
              </div>
              
              <Link to="/contact" className={styles.btnPrimary}>
                <FaQuestionCircle aria-hidden="true" /> Meer informatie
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Activities Grid */}
      <section className={styles.activitiesSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h3>Voorbeelden van activiteiten</h3>
            <p>Een impressie van onze dagelijkse activiteiten</p>
          </div>
          
          <div className={styles.activitiesGrid}>
            {activities.map((activity, index) => {
              const Icon = activity.icon
              return (
                <div key={index} className={styles.activityCard}>
                  <div className={styles.activityIcon}>
                    <Icon aria-hidden="true" />
                  </div>
                  <h4>{activity.title}</h4>
                  <p>{activity.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* Individuele Begeleiding */}
      <section id="begeleiding" className={styles.serviceSection}>
        <div className="container">
          <div className={`${styles.serviceGrid} ${styles.reverse}`}>
            <div className={`${styles.serviceContent} fade-in`}>
              <div className={`${styles.badge} ${styles.badgeSecondary}`}>
                <FaUserCheck aria-hidden="true" /> Individuele Begeleiding
              </div>
              <h2>Persoonlijke begeleiding op maat</h2>
              <p>
                Onze individuele begeleiding is volledig afgestemd op de persoonlijke doelen, 
                wensen en mogelijkheden van de cliënt. Eén-op-één ondersteuning bij het 
                ontwikkelen van vaardigheden en het bereiken van doelen.
              </p>
              <p>
                Of het nu gaat om zelfstandig wonen, werk zoeken, sociale contacten opbouwen 
                of administratieve zaken - wij bieden de ondersteuning die nodig is.
              </p>
              
              <div className={styles.highlightBox}>
                <h4>Onze begeleiding helpt bij:</h4>
                <ul className={styles.checkList}>
                  <li><FaCheck aria-hidden="true" /> Ontwikkeling van dagelijkse vaardigheden</li>
                  <li><FaCheck aria-hidden="true" /> Maatschappelijke participatie en sociale contacten</li>
                  <li><FaCheck aria-hidden="true" /> Administratieve ondersteuning</li>
                  <li><FaCheck aria-hidden="true" /> Begeleiding naar werk of opleiding</li>
                  <li><FaCheck aria-hidden="true" /> Ondersteuning bij (zelf)zorg</li>
                </ul>
              </div>
              
              <Link to="/contact" className={styles.btnSecondary}>
                <FaEnvelope aria-hidden="true" /> Plan een kennismaking
              </Link>
            </div>
            <div className={`${styles.serviceImage} fade-in-delay`}>
              <img 
                src="/assets/img/individuele-begeleiding.jpg" 
                alt="Persoonlijke begeleiding bij Sobé Zorg Twente - begeleider met cliënt tijdens een uitstapje"
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = 'https://images.unsplash.com/photo-1573496774426-fe3db3dd1731?w=800&h=600&fit=crop'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vervoer Section */}
      <section id="vervoer" className={styles.vervoerSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <div className={styles.badge}>
              <FaBus aria-hidden="true" /> Vervoer
            </div>
            <h2>Vervoer van en naar dagbesteding</h2>
            <p>Veilig en comfortabel vervoer voor onze deelnemers</p>
          </div>
          
          <div className={styles.vervoerGrid}>
            <div className={styles.vervoerCard}>
              <div className={styles.vervoerIcon}>
                <FaHome aria-hidden="true" />
              </div>
              <h4>Ophalen thuis</h4>
              <p>Wij halen u op bij het woonadres en brengen u veilig naar onze locatie</p>
            </div>
            <div className={styles.vervoerCard}>
              <div className={styles.vervoerIcon}>
                <FaClock aria-hidden="true" />
              </div>
              <h4>Betrouwbaar</h4>
              <p>Vaste tijden en routes voor een gestructureerde en voorspelbare dag</p>
            </div>
            <div className={styles.vervoerCard}>
              <div className={styles.vervoerIcon}>
                <FaHeart aria-hidden="true" />
              </div>
              <h4>Persoonlijke service</h4>
              <p>Vriendelijke chauffeurs die rekening houden met uw individuele behoeften</p>
            </div>
          </div>
        </div>
      </section>

      {/* Kosten en Indicatie */}
      <section className={styles.indicatieSection}>
        <div className="container">
          <div className={styles.indicatieCard}>
            <div className={styles.indicatieIcon}>
              <FaFileMedical aria-hidden="true" />
            </div>
            <h2>Kosten en indicatie</h2>
            <p className={styles.subtitle}>Hoe werkt de financiering van onze zorg?</p>
            
            <div className={styles.indicatieContent}>
              <div className={styles.indicatieItem}>
                <h4>WLZ indicatie</h4>
                <p>
                  Voor dagbesteding en begeleiding heeft u een WLZ indicatie nodig van het CIZ 
                  (Centrum Indicatiestelling Zorg). Wij helpen u graag bij 
                  het aanvragen van deze indicatie.
                </p>
              </div>
              
              <div className={styles.indicatieItem}>
                <h4>Eigen bijdrage</h4>
                <p>
                  De hoogte van uw eigen bijdrage is afhankelijk van uw inkomen en wordt 
                  berekend door het CAK (Centraal Administratie Kantoor). Veel van onze 
                  cliënten betalen geen of een lage eigen bijdrage.
                </p>
              </div>
              
              <div className={styles.indicatieItem}>
                <h4>Hulp bij aanvragen</h4>
                <p>
                  Ons team staat klaar om u te helpen bij het aanvragen van de juiste 
                  indicatie en het regelen van de financiering. Neem gerust contact met 
                  ons op voor een vrijblijvend gesprek.
                </p>
              </div>
            </div>
            
            <Link to="/contact" className={styles.btnPrimary}>
              <FaQuestionCircle aria-hidden="true" /> Vragen over indicatie?
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className={styles.ctaSection}>
        <div className="container">
          <h2>Interesse in onze diensten?</h2>
          <p>Neem contact op voor een vrijblijvende kennismaking</p>
          <div className={styles.ctaButtons}>
            <Link to="/contact" className={styles.btnPrimary}>
              <FaEnvelope aria-hidden="true" /> Neem contact op
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Services
